
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data() {
    return { story: null };
  },
  methods: {
    fetchStory(id) {
      var self = this;
      var app = self.$app;
      app.request.json('https://api.hnpwa.com/v0/item/' + id + '.json', story => {
        self.$setState({ story: story });
      });
    }
  },
  on: {
    pageInit(e, page) {
      var self = this;
      var app = self.$app;
      self.fetchStory(self.$route.params.id);
    }
  },
  id: '0c02e68aa6',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page" data-name="story">\n      <!-- navbar -->\n      <div class="navbar">\n        <div class="navbar-inner sliding">\n          <div class="left">\n            <a href="#" class="link back">\n              <i class="icon icon-back"></i>\n              <span class="ios-only">Back</span>\n            </a>\n          </div>\n          ';
      if (ctx_1.story) {
        if (isArray(ctx_1.story)) {
          r += Template7Helpers.each.call(ctx_1, ctx_1.story, {
            hash: {},
            data: data_1 || {},
            fn: function (ctx_2, data_2) {
              var r = '';
              r += '\n          <div class="title">';
              r += c(ctx_2.title, ctx_2);
              r += '</div>\n          ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
        } else {
          r += Template7Helpers.with.call(ctx_1, ctx_1.story, {
            hash: {},
            data: data_1 || {},
            fn: function (ctx_2, data_2) {
              var r = '';
              r += '\n          <div class="title">';
              r += c(ctx_2.title, ctx_2);
              r += '</div>\n          ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
        }
      }
      r += '\n        </div>\n      </div>\n    \n      <!-- Page content -->\n      <div class="page-content messages-content">\n        <div class="messages messages-init" data-new-messages-first="true">\n        ';
      if (ctx_1.story) {
        if (isArray(ctx_1.story)) {
          r += Template7Helpers.each.call(ctx_1, ctx_1.story, {
            hash: {},
            data: data_1 || {},
            fn: function (ctx_2, data_2) {
              var r = '';
              r += '\n          <div class="messages-title">';
              r += c(ctx_2.title, ctx_2);
              r += '</div>\n          <div class="messages-title">';
              r += c(ctx_2.points, ctx_2);
              r += ' ';
              r += Template7Helpers.pluralize.call(ctx_2, ctx_2.points, {
                hash: {
                  'single': 'point',
                  'multiple': 'points'
                },
                data: data_2 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_1]
              });
              r += ' ';
              r += Template7Helpers.if.call(ctx_2, ctx_2.user, {
                hash: {},
                data: data_2 || {},
                fn: function (ctx_3, data_3) {
                  var r = '';
                  r += ' by ';
                  r += c(ctx_3.user, ctx_3);
                  r += ' ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_1]
              });
              r += c(ctx_2.time_ago, ctx_2);
              r += '</div>\n          <div class="messages-title"><a href="';
              r += c(ctx_2.url, ctx_2);
              r += '" class="external">';
              r += c(ctx_2.domain, ctx_2);
              r += '</a></div>\n          ';
              r += Template7Helpers.if.call(ctx_2, ctx_2.content, {
                hash: {},
                data: data_2 || {},
                fn: function (ctx_3, data_3) {
                  var r = '';
                  r += '<div class="block block-strong">';
                  r += c(ctx_3.content, ctx_3);
                  r += '</div>';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_1]
              });
              r += '\n          ';
              r += Template7Helpers._partial.call(ctx_2, 'comments', {
                hash: {},
                data: data_2 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_1]
              });
              r += '\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
        } else {
          r += Template7Helpers.with.call(ctx_1, ctx_1.story, {
            hash: {},
            data: data_1 || {},
            fn: function (ctx_2, data_2) {
              var r = '';
              r += '\n          <div class="messages-title">';
              r += c(ctx_2.title, ctx_2);
              r += '</div>\n          <div class="messages-title">';
              r += c(ctx_2.points, ctx_2);
              r += ' ';
              r += Template7Helpers.pluralize.call(ctx_2, ctx_2.points, {
                hash: {
                  'single': 'point',
                  'multiple': 'points'
                },
                data: data_2 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_1]
              });
              r += ' ';
              r += Template7Helpers.if.call(ctx_2, ctx_2.user, {
                hash: {},
                data: data_2 || {},
                fn: function (ctx_3, data_3) {
                  var r = '';
                  r += ' by ';
                  r += c(ctx_3.user, ctx_3);
                  r += ' ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_1]
              });
              r += c(ctx_2.time_ago, ctx_2);
              r += '</div>\n          <div class="messages-title"><a href="';
              r += c(ctx_2.url, ctx_2);
              r += '" class="external">';
              r += c(ctx_2.domain, ctx_2);
              r += '</a></div>\n          ';
              r += Template7Helpers.if.call(ctx_2, ctx_2.content, {
                hash: {},
                data: data_2 || {},
                fn: function (ctx_3, data_3) {
                  var r = '';
                  r += '<div class="block block-strong">';
                  r += c(ctx_3.content, ctx_3);
                  r += '</div>';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_1]
              });
              r += '\n          ';
              r += Template7Helpers._partial.call(ctx_2, 'comments', {
                hash: {},
                data: data_2 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_1]
              });
              r += '\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
        }
      }
      r += '\n        </div>\n      </div>\n    </div>\n    ';
      return r;
    }(this);
  },
  styleScoped: false
};
    